import * as React from 'react'
import { FC, PropsWithChildren } from 'react'

import styles from './PageWrapper.module.scss'

const PageWrapper: FC<PropsWithChildren> = ({ children }) => <div className={styles.pageWrapper}>{children}</div>

export default PageWrapper
